import { COMPANY } from './company';

export const privacy = {
  tr: {
    title: 'Gizlilik Politikası',
    intro: `${COMPANY.name} olarak gizliliğinize önem veriyoruz. Bu politika, ${COMPANY.website} web sitesini kullanırken hangi bilgileri topladığımızı, nasıl kullandığımızı ve nasıl koruduğumuzu açıklar.`,
    sections: [
      {
        heading: 'Topladığımız Bilgiler',
        items: [
          'Bize ilettiğiniz bilgiler: ad, e-posta, telefon, şirket adı ve mesaj içeriği.',
          'Randevu bilgileri: Google Takvim üzerinden görüşme planladığınızda paylaştığınız bilgiler.',
          'Teknik bilgiler: IP adresi, tarayıcı türü, cihaz bilgisi ve ziyaret zamanı.',
          'Çerez verileri: Çerez Politikamızda açıklanan ve onayınıza bağlı çerezler.',
        ],
      },
      {
        heading: 'Bilgileri Nasıl Kullanıyoruz',
        items: [
          'Taleplerinize yanıt vermek ve danışmanlık görüşmeleri planlamak.',
          'Size özel teklif hazırlamak ve hizmet sunmak.',
          'Siteyi güvende tutmak, spam ve kötüye kullanımı engellemek.',
          'Onay vermeniz halinde site performansını ölçmek ve deneyimi iyileştirmek.',
        ],
      },
      {
        heading: 'Bilgilerin Paylaşılması',
        body: [
          'Bilgilerinizi satmıyor veya kiralamıyoruz. Yalnızca hizmetlerimizi sunmamıza yardımcı olan güvenilir sağlayıcılarla (barındırma, e-posta iletimi, randevu planlama) ve yasal zorunluluk halinde yetkili makamlarla paylaşırız.',
        ],
      },
      {
        heading: 'Saklama Süresi',
        body: [
          'Kişisel verilerinizi işleme amacının gerektirdiği süre ve yasal saklama yükümlülükleri boyunca saklarız. Bu sürelerin sonunda verileriniz silinir, yok edilir veya anonim hale getirilir.',
        ],
      },
      {
        heading: 'Güvenlik',
        body: [
          'Verilerinizi korumak için şifreli bağlantı (HTTPS), erişim kısıtlaması, form gönderim sınırlaması ve düzenli güvenlik kontrolleri gibi teknik ve idari tedbirler uyguluyoruz. Ancak internet üzerinden yapılan hiçbir aktarımın %100 güvenli olmadığını hatırlatırız.',
        ],
      },
      {
        heading: 'Haklarınız',
        body: [
          'KVKK ve (Avrupa Birliği\'ndeki ziyaretçiler için) GDPR kapsamında verilerinize erişme, düzeltme, silme, işlemeye itiraz etme ve onayınızı geri çekme haklarına sahipsiniz. Ayrıntılar için KVKK Aydınlatma Metnimizi inceleyebilirsiniz.',
        ],
      },
      {
        heading: 'Çocukların Gizliliği',
        body: ['Hizmetlerimiz işletmelere yöneliktir; 18 yaşından küçüklerden bilerek kişisel veri toplamayız.'],
      },
      {
        heading: 'Üçüncü Taraf Bağlantılar',
        body: ['Sitemiz başka web sitelerine bağlantılar içerebilir. Bu sitelerin gizlilik uygulamalarından sorumlu değiliz.'],
      },
      {
        heading: 'Değişiklikler ve İletişim',
        body: [
          `Bu politikayı zaman zaman güncelleyebiliriz; güncel sürüm her zaman bu sayfada yer alır. Sorularınız için ${COMPANY.email} adresinden bize ulaşabilirsiniz.`,
        ],
      },
    ],
  },
  en: {
    title: 'Privacy Policy',
    intro: `At ${COMPANY.name}, we care about your privacy. This policy explains what information we collect when you use ${COMPANY.website}, how we use it and how we protect it.`,
    sections: [
      {
        heading: 'Information We Collect',
        items: [
          'Information you give us: name, email, phone, company name and message content.',
          'Appointment details: information you share when booking a call via Google Calendar.',
          'Technical information: IP address, browser type, device details and time of visit.',
          'Cookie data: cookies described in our Cookie Policy, subject to your consent.',
        ],
      },
      {
        heading: 'How We Use Information',
        items: [
          'To respond to your requests and schedule consultancy calls.',
          'To prepare tailored proposals and deliver our services.',
          'To keep the site secure and prevent spam and abuse.',
          'With your consent, to measure site performance and improve the experience.',
        ],
      },
      {
        heading: 'Sharing Information',
        body: [
          'We do not sell or rent your information. We share it only with trusted providers that help us run our services (hosting, email delivery, appointment scheduling) and with competent authorities when legally required.',
        ],
      },
      {
        heading: 'Retention',
        body: [
          'We keep personal data for as long as the purpose of processing requires and as legal retention obligations demand. After that, it is deleted, destroyed or anonymised.',
        ],
      },
      {
        heading: 'Security',
        body: [
          'We apply technical and organisational measures such as encrypted connections (HTTPS), restricted access, form submission limits and regular security reviews. Please note that no transmission over the internet is 100% secure.',
        ],
      },
      {
        heading: 'Your Rights',
        body: [
          'Under the KVKK and, for visitors in the European Union, the GDPR, you have the right to access, correct and delete your data, object to processing and withdraw your consent. See our KVKK Information Notice for details.',
        ],
      },
      {
        heading: 'Children\'s Privacy',
        body: ['Our services are aimed at businesses; we do not knowingly collect personal data from anyone under 18.'],
      },
      {
        heading: 'Third-Party Links',
        body: ['Our site may link to other websites. We are not responsible for their privacy practices.'],
      },
      {
        heading: 'Changes and Contact',
        body: [
          `We may update this policy from time to time; the current version is always on this page. For any questions, reach us at ${COMPANY.email}.`,
        ],
      },
    ],
  },
};
